export interface WidgetData {
    country: string;
    hotelCount: number;
    id: number;
    latitude: string;
    longitude: string;
    name: string;
    placeKey: string;
}

interface WidgetError {
    error: string;
}

const options = {
    headers: {
        Accept: 'application/json',
    },
};

export const fetchData = async (
    latSw,
    lngSw,
    latNe,
    lngNe,
    country,
    dataUrl = '/reise/hotell/api/widget/'
): Promise<WidgetData | WidgetError> =>
    fetch(`${dataUrl}?latSw=${latSw}&lngSw=${lngSw}&latNe=${latNe}&lngNe=${lngNe}&country=${country}`, options)
        .then(async (res) => {
            if (res.status >= 200 && res.status < 300) {
                return (await res.json())?.[0];
            }
            return { error: `${res.status} ${res.statusText}` };
        })
        .catch((error) => ({ error }));
